module.exports = {
  conf:{
    // Dev defaults to the local famewall-backend, but honours REACT_APP_HOST
    // when it's set (put it in .env.local) so a machine that can't reach the
    // backend's VPC-private MongoDB can still develop against the public
    // read-only production API: REACT_APP_HOST=https://apifame.famewall.io
    "development": {
      "REACT_APP_HOST": process.env.REACT_APP_HOST || "http://localhost:7000",
      "REACT_TINY_TOK": process.env.REACT_TINY_TOK || ""
    },
    "production":
    {
      "REACT_APP_HOST": `${process.env.REACT_APP_HOST}`,
      "REACT_TINY_TOK": `${process.env.REACT_TINY_TOK}`
    }
  }
  };